import styled, { css } from 'styled-components';

import BackgroundSvg from '../../../assets/icons/BackgroundSvg';
import ElementsSvg from '../../../assets/icons/ElementsSvg';
import InteractiveElementsSvg from '../../../assets/icons/InteractiveElementsSvg';
import { MagicWandSvg } from '../../../assets/icons/MagicWandSvg';
import MediaIconSvg from '../../../assets/icons/MediaIconSvg';
import PromptsSvg from '../../../assets/icons/PromptsSvg';
import TestCasesSvg from '../../../assets/icons/TestCasesSvg';
import { TextSvg } from '../../../assets/icons/TextSvg';
import TranslateSvg from '../../../assets/icons/TranslateSvg';
import UploadsSvg from '../../../assets/icons/UploadsSvg';
import theme from '../../../assets/theme';
import { MOBILE_TO_DESKTOP_BREAKPOINT_PX } from '../../../utils/creator';
import { Button } from '../../_atoms/Button';

export type LeftMenuTabTypes =
  | 'generators'
  | 'interactiveElements'
  | 'background'
  | 'media'
  | 'elements'
  | 'uploads'
  | 'templates'
  | 'translate'
  | 'prompts'
  | 'testCases'
  | 'testCasesResult'
  | 'editAiFeedback'
  | 'text'
  | 'colorPicker'
  | 'attachments'
  | 'none';

export const TabSelectorButtonMapper: {
  tabTitle: LeftMenuTabTypes;
  icon: JSX.Element;
  displayTitle: string;
}[] = [
  {
    tabTitle: 'generators',
    icon: <MagicWandSvg />,
    displayTitle: 'Add new',
  },
  {
    tabTitle: 'interactiveElements',
    icon: <InteractiveElementsSvg />,
    displayTitle: 'Edit activity',
  },
  {
    tabTitle: 'text',
    icon: <TextSvg />,
    displayTitle: 'Text',
  },
  {
    tabTitle: 'media',
    icon: <MediaIconSvg />,
    displayTitle: 'Media',
  },
  {
    tabTitle: 'elements',
    icon: <ElementsSvg />,
    displayTitle: 'Elements',
  },
  {
    tabTitle: 'background',
    icon: <BackgroundSvg />,
    displayTitle: 'Background',
  },
  {
    tabTitle: 'uploads',
    icon: <UploadsSvg />,
    displayTitle: 'Uploads',
  },
  {
    tabTitle: 'translate',
    icon: <TranslateSvg />,
    displayTitle: 'Translate',
  },
  {
    tabTitle: 'prompts',
    icon: <PromptsSvg />,
    displayTitle: 'Prompts',
  },
  {
    tabTitle: 'testCases',
    icon: <TestCasesSvg />,
    displayTitle: 'Test cases',
  },
];

export const TabSelectorButton = styled(Button)<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  max-height: 60px;
  height: 60px;
  min-width: 70px;
  width: 70px;
  margin: 10px auto;
  border: none;
  padding: 0;
  box-shadow: none;
  color: ${theme.colors.greyDark};

  span {
    font-size: 12px;
    margin-top: 5px;
    white-space: normal;
    line-height: 14px;
    color: inherit;
    margin-bottom: 0px;
    font-weight: 800;
    width: 100%;
  }
  svg {
    width: 25px;
    height: 25px;
    margin: 0px;
  }

  &:focus,
  &:hover {
    color: ${theme.colors.orange};
    background: rgba(255, 161, 84, 0.15);
  }

  &:active {
    background: rgba(255, 161, 84, 0.3);
  }

  ${({ $active }) =>
    $active &&
    css`
      color: ${theme.colors.orange};
      background: ${theme.colors.backgroundTransparent};
    `}

  @media (max-width: ${MOBILE_TO_DESKTOP_BREAKPOINT_PX}px) {
    margin: 5px;
  }
`;

export const TabContainer = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  height: 100%;
`;
